module.exports = __webpack_public_path__ + "img/Categories_bg_003.b4165592.jpg";